// src/util/dialog-util.js

/**
 * Helper centralizado para mostrar diálogos (confirmaciones, alertas, errores, etc.)
 * Compatible con Buefy (Vue 2.7)
 */
export const DialogUtil = {
  /**
   * Confirmación con callback.
   * @param {VueComponent} ctx - Contexto del componente (this)
   * @param {String} message - Mensaje HTML o texto plano
   * @param {Function} onConfirm - Función asíncrona o síncrona a ejecutar si confirma
   * @param {Object} [options={}] - Configuración adicional (tipo, título, etc.)
   */
  confirm(ctx, message, onConfirm, options = {}) {
    ctx.$dialog.confirm({
      title: options.title || "Confirmar acción",
      message,
      confirmText: options.confirmText || "Sí, continuar",
      cancelText: options.cancelText || "Cancelar",
      type: options.type || "is-info",
      hasIcon: options.hasIcon !== false,
      icon: options.icon || "check-circle",
      onConfirm,
    });
  },

  /**
   * Diálogo simple de información o éxito.
   */
  success(ctx, message, options = {}) {
    ctx.$dialog.alert({
      title: options.title || "Operación exitosa",
      message,
      type: "is-success",
      hasIcon: true,
      icon: options.icon || "check-circle",
      confirmText: options.confirmText || "Aceptar",
    });
  },

  /**
   * Diálogo de error o advertencia.
   */
  error(ctx, message, options = {}) {
    ctx.$dialog.alert({
      title: options.title || "Error",
      message,
      type: "is-danger",
      hasIcon: true,
      icon: options.icon || "alert-circle",
      confirmText: options.confirmText || "Cerrar",
    });
  },

  /**
   * Diálogo de advertencia sin bloquear flujo.
   */
  warning(ctx, message, options = {}) {
    ctx.$dialog.alert({
      title: options.title || "Advertencia",
      message,
      type: "is-warning",
      hasIcon: true,
      icon: options.icon || "alert-triangle",
      confirmText: options.confirmText || "Entendido",
    });
  },

  /**
   * Diálogo informativo (neutral, tipo "is-info").
   */
  info(ctx, message, options = {}) {
    ctx.$dialog.alert({
      title: options.title || "Información",
      message,
      type: "is-info",
      hasIcon: true,
      icon: options.icon || "information-outline",
      confirmText: options.confirmText || "Aceptar",
    });
  }

};



// WEBPACK FOOTER //
// ./src/util/dialog-util.js